import axios from 'axios'
import apiUrl from '../config'
import router from '../router'
import store from 'store'

axios.defaults.baseURL = apiUrl.url

export const login = ({ commit, state }, cred) => {
  axios.post('/api/login', cred).then((response) => {
    commit('UPDATE_AUTH', {
      isLoggedIn: true,
      user: response.data.user,
      accessToken: response.data.token

    })
  }, (err) => {
    console.log(err)
    commit('showNotify', {title: 'Login Invalid', text: 'The login is invalid', type: 'error'})
  })
}

export const checkNumber = ({ commit, state }, cred) => {
  axios.post('/api/check-number', cred).then((response) => {
    commit('requestValidationSend', true)
  }, (err) => {
    console.log(err)
    commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
  })
}

export const validatePhone = ({ commit, state }, cred) => {
  axios.post('/api/validate-phone', cred).then((response) => {
    commit('requestValidationSend', true)
  }, (err) => {
    console.log(err)
    commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
  })
}

export const validatePhoneCode = ({ commit, state }, cred) => {
  axios.post('/api/check-code', cred).then((response) => {
    commit('validatePhoneNumber', true)
  }, (err) => {
    console.log(err)
    commit('showNotify', {title: 'Validation Error', text: err.response.data.error, type: 'error'})
  })
}

export const register = ({ commit, state }, cred) => {
  axios.post('/api/register', cred).then((response) => {
    commit('UPDATE_AUTH', {
      isLoggedIn: true,
      user: response.data.user,
      accessToken: response.data.token })
  }, (err) => {
    console.log(err)
    commit('showNotify', {title: 'Validation Error', text: err.response.data.error, type: 'error'})
  })
}

export const getPhoneNumberList = ({ commit, state }, cred) => {
  axios.get('/api/phone-numbers', {headers: {
    'Authorization': 'Bearer ' + state.auth.accessToken
  }}).then((response) => {
    commit('updatePhoneNumberList', response.data.numbers)
  }, (err) => {
    console.log(err)
    commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
  })
}

export const checkTokenValidity = ({ commit, state }, cred) => {
  if (!state.auth.accessToken) {
    return
  }
  axios.get('/api/check-token', {headers: {
    'Authorization': 'Bearer ' + state.auth.accessToken
  }}).then((response) => {
    commit('UPDATE_BILLING_STATE', {current_subscription_status: response.data.current_subscription_status, is_trial: response.data.is_trial, trial_ends_at: response.data.trial_ends_at})
  }, (err) => {
    console.log(err)
    router.push({ path: '/login' })
    commit('CLEAR_ALL_DATA')
  })
}

export const getAccountsVipPages = ({ commit, state }, cred) => {
  if (!state.auth.accessToken) {
    return
  }
  axios.get('/api/read_accounts_templates/' + state.auth.user.account_id.id, {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }}).then((response) => {
      commit('getAccountVipTemplate', response.data.templates, response.data.slug)
      commit('getAccountVipIcons', response.data.vipIcons)
    }, (err) => {
      console.log(err)
      commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
    })
}

export const getSlug = ({ commit, state }, cred) => {
  if (!state.auth.accessToken) {
    return
  }
  axios.get('/api/read_accounts_templates/' + state.auth.user.account_id.id, {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }}).then((response) => {
      commit('getPromotionSlug', response.data.slug)
    }, (err) => {
      console.log(err)
      commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
    })
}

export const updateVipTemplate = ({ commit, state }, cred) => {
  axios.put('/api/update_templates/' + state.vip_template.id, state.vip_template, {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }
  }).then((response) => {
    commit('showNotify', {title: 'Success', text: 'Setup pages was updated', type: 'success'})
  }, (err) => {
    console.log(err)
    commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
  })
}

export const updateUserAccounts = ({ commit, state }, data) => {
  let toUpdate = state.auth.user

  toUpdate.password = data.password

  axios.put('/api/accounts/' + state.auth.user.id, toUpdate, {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }
  }).then((response) => {
    if (data.showNotfication) {
      commit('showNotify', {title: 'Success', text: 'Your account was updated', type: 'success'})
    }
  }, (err) => {
    console.log(err)
    commit('showNotify', {title: 'Request Invalid', text: 'The account was not updated', type: 'error'})
  })
}

export const getVipKeywords = ({ commit, state }, cred) => {
  if (!state.auth.accessToken) {
    return
  }
  axios.get('/api/keyword', {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }}).then((response) => {
      commit('setVipKeywords', response.data.keywords)
    }, (err) => {
      console.log(err)
      commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
    })
}

export const getPromotions = ({ commit, state }) => {
  if (!state.auth.accessToken) {
    return
  }
  axios.get('api/promotions-list', {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }}).then((response) => {
      commit('getPromotions', response.data)
    }, (err) => {
      console.log(err)
      commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
    })
}

export const getCampaigns = ({ commit, state }) => {
  if (!state.auth.accessToken) {
    return
  }
  axios.get('api/campaigns', {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }}).then((response) => {
      commit('getCampaigns', response.data.campaigns)
    }, (err) => {
      console.log(err)
      commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
    })
}

export const getPermanentCampaigns = ({ commit, state }) => {
  if (!state.auth.accessToken) {
    return
  }

  return new Promise((resolve, reject) => {
        // Do something here... lets say, a http call using vue-resource

    axios.get('api/permanent_campaigns', {
      headers: {
        'Authorization': 'Bearer ' + state.auth.accessToken
      }}).then((response) => {
        commit('getPermanentCampaigns', response.data.permanentCampaigns)
        resolve(response)
      }, (err) => {
        console.log(err)
        commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
        reject(err)
      })
  })
}

export const updatePermanentCampaigns = ({ commit, state }, cred) => {
  axios.put('/api/campaigns/' + state.permanentCampaigns.id, state.permanentCampaigns, {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }
  }).then((response) => {
    commit('showNotify', {title: 'Success', text: 'Permanent campaign was updated', type: 'success'})
  }, (err) => {
    console.log(err)
    commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
  })
}

export const getStaff = ({ commit, state }) => {
  if (!state.auth.accessToken) {
    return
  }
  axios.get('api/get-staff', {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }}).then((response) => {
      commit('getStaff', response.data.staff)
    }, (err) => {
      console.log(err)
      commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
    })
}

export const getPromotion = ({ commit, state }) => {
  if (!state.auth.accessToken) {
    return
  }
  axios.get('api/promotion' + state.promotion.id, {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }}).then((response) => {
      commit('getPromotion', response.data.promotion)
    }, (err) => {
      console.log(err)
      commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
    })
}

export const getDashboard = ({ commit, state }) => {
  if (!state.auth.accessToken) {
    return
  }
  axios.get('api/dashboard', {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }}).then((response) => {
      commit('getDashboard', response.data)
    }, (err) => {
      console.log(err)
      commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
    })
}

export const getCreditStatus = ({ commit, state }) => {
  if (!state.auth.accessToken) {
    return
  }
  axios.get('api/credit', {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }}).then((response) => {
      commit('getCreditStatus', response.data.credit)
      commit('UPDATE_USER', response.data.user)

      // commit('getDashboard', response.data.week_leads)
    }, (err) => {
      console.log(err)
      commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
    })
}

export const getViralCampaign = ({ commit, state }) => {
  if (!state.auth.accessToken) {
    return
  }

  return new Promise((resolve, reject) => {
    // Do something here... lets say, a http call using vue-resource
    axios.get('api/viral-campaign', {
      headers: {
        'Authorization': 'Bearer ' + state.auth.accessToken
      }}).then((response) => {
        commit('getViralCampaign', response.data.viralCampaign)
        resolve(response)
      }, (err) => {
        console.log(err)
        commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
        reject(err)
      })
  })
}

export const updateViralCampaign = ({ commit, state }, cred) => {
  axios.put('/api/campaigns/' + state.viralCampaign.id, state.viralCampaign, {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }
  }).then((response) => {
    commit('showNotify', {title: 'Success', text: 'Viral Share campaign was updated', type: 'success'})
  }, (err) => {
    console.log(err)
    commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
  })
}

export const getViralPermanent = ({ commit, state }) => {
  if (!state.auth.accessToken) {
    return
  }

  return new Promise((resolve, reject) => {
    // Do something here... lets say, a http call using vue-resource
    axios.get('api/viral-permanent', {
      headers: {
        'Authorization': 'Bearer ' + state.auth.accessToken
      }}).then((response) => {
        commit('getViralPermanent', response.data.viralPermanent)
        resolve(response)
      }, (err) => {
        console.log(err)
        commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
        reject(err)
      })
  })
}

export const updateViralPermanent = ({ commit, state }, cred) => {
  axios.put('/api/campaigns/' + state.viralPermanent.id, state.viralPermanent, {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }
  }).then((response) => {
    commit('showNotify', {title: 'Success', text: 'Permanent Viral Message was updated', type: 'success'})
  }, (err) => {
    console.log(err)
    commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
  })
}

export const getCart = ({commit, state}) => {
  commit('getCart', store.get('cart'))
}
export const getAccountNotifications = ({ commit, state }) => {
  if (!state.auth.accessToken) {
    return
  }
  axios.get('api/notifications', {
    headers: {
      'Authorization': 'Bearer ' + state.auth.accessToken
    }}).then((response) => {
      commit('getAccountNotifications', response.data.notifications)
    }, (err) => {
      console.log(err)
      commit('showNotify', {title: 'Request Invalid', text: 'The request data is invalid', type: 'error'})
    })
}



// WEBPACK FOOTER //
// ./src/store/actions.js